import { render } from "./DeleteFromAllListsAction.vue?vue&type=template&id=6cea8391"
import script from "./DeleteFromAllListsAction.vue?vue&type=script&lang=ts"
export * from "./DeleteFromAllListsAction.vue?vue&type=script&lang=ts"
script.render = render

export default script